import reduceForSummary from './reduceForSummary'

export default reduceForSummary
